// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 502 ? "GalleryImageElement" : chunkId) + "." + {"3":"93d94261a53f69fa","502":"4b78f766fd5e74a2"}[chunkId] + ".js";
};